import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, TextField, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {EditTwoTone} from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import DropDown from './DropDown';
import DatePicker from './DatePicker';

export default class AssignInterventions extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            interventions_array: [],
            intervention_templates_array: [],
            assign_view: false,
            search_name: '',
            search_number: '',
            search_ready: false,
            searching: false,
            current_record: {},
            nominees_array: [],
            show_assignees: false,
            creating_nomination: false,
            selected_template: null,
            deadline: null,
            editing: false,
            bulk_assign: false,
            refresh_required: false,
        }

        this.state = this.initial_state;

        this.datasheetFieldSpecs = [
            { field: 'employee', headerName: 'Employee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'intervention', headerName: 'Learning Intervention', width: 250},
            { field: 'created', headerName: 'Assigned', width: 120},
            { field: 'edit', headerName: 'Edit', width: 70, headerAlign: 'center', align: 'center',
            sortable: false,
            renderCell: (parms) => (    
                <IconButton 
                    onClick={()=>this.editRecord(parms)} 
                >
                    <EditTwoTone/>
                </IconButton>
            )},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'nominate', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.createNom(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Assign
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = () => {

        //async query templates...
        if (this.state.intervention_templates_array.length<1) {
            Gserv.sendCommand('query_intervention_template',this.props.gwt)
            .then(reply=>{
                // console.log('query_interventions reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_intervention_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_intervention_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({intervention_templates_array:reply.Records?reply.Records : []});
                }
            });
        }

        Gserv.sendCommand('query_my_assigned_interventions',this.props.gwt)
        .then(reply=>{
            // console.log('query_my_assigned_interventions :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_my_assigned_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_my_assigned_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    let created = null;
                    for (var i=0;i<record_array.length;i++){
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].deadline_date){
                            deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                            record_array[i].deadline_date = deadline_date;
                        }
                    }
                }
                this.setState({querying:false, interventions_array:reply.Records?reply.Records : []});

            }
        });

    };
    
    createNom = (parms) => {
        // console.log('parms :>> ', parms);
        this.setState({creating_nomination:true, search_ready:false});
        Gserv.sendCommand('assign_intervention',this.props.gwt,{
            intervention: this.state.selected_template,
            assignee: parms.row.id,
            deadline_date: this.state.deadline
        })
        .then(reply => {
            // console.log('createNom reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (assign_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (assign_intervention) :>> ', reply);
                this.setState({error:true,error_message:"Unable to assign this intervention to this employee - intervention already assigned and/or already completed."});                
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (assign_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else {
                this.setState({search_name:'',search_ready:false,creating_nomination:false,show_assignees:false,nominees_array:[], refresh_required:true});
            }
        });
    }

    // openSearch = (parms) => {
    //     // console.log('edit assessments with parms :>> ', parms);
    //     this.setState({current_record:parms.row,assign_view:true});
    // }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false,nominees_array:[]});
        Gserv.sendCommand('find_users_for_intervention',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number'
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search.",searching:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({nominees_array:reply.Records,show_assignees:true,searching:false,search_ready:true});
            }
        });
    }

    runViewAll = () => {
        // console.log('e :>> ', e);
        this.setState({searching:true, search_ready:false,nominees_array:[]});
        Gserv.sendCommand('find_users_for_intervention',this.props.gwt,{
            search_string: "~~~",
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_intervention) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search.",searching:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({nominees_array:reply.Records,show_assignees:true,searching:false,search_ready:true});
            }
        });
    }

    resetMe = () => {
        console.log('called resetme...');
        if (this.state.editing){
            this.setState({search_name:'', search_number: '',searching:false,error:false,error_message:'',search_ready:false,show_assignees:false,creating_nomination:false, editing:false,assign_view:false});
        } else {
            this.setState({search_name:'', search_number: '',searching:false,error:false,error_message:'',search_ready:false,show_assignees:false,creating_nomination:false, editing:false});
        }
    }

    handleSelectUpdate = (fieldObj) => {
        if (fieldObj.value===''){fieldObj.value=null}
        this.setState({selected_template:fieldObj.value})
    }

    handleDeadlineUpdate = (fieldObj) => {
        if (fieldObj.value===''){fieldObj.value=null}
        this.setState({deadline:fieldObj.value})
    }

    editRecord = (parms) => {
        // console.log('record :>> ', record);
        // console.log('record.row.deadline_date :>> ', record.row.deadline_date);
        this.setState({current_record:parms.row,assign_view:true,editing:true});
    }

    handleDelete = (record) => {
        // console.log('record :>> ', record);

        if (record.row.approved){

            this.setState({error:true,error_message:'Unable to delete assessments which have already been approved.'});

        } else {

            this.setState({querying:true});
            Gserv.sendCommand('delete_intervention',this.props.gwt,{
                intervention_id: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_intervention) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_intervention) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({error:false,error_message:'',interventions_array:[]});
                    this.componentDidMount();
                }
            });

        }

    }

    cancelUpdate = () => {
        // console.log('called cancelUpate')
        if (this.state.refresh_required){
            this.setState({assign_view:false,search_name:'',search_ready:false,searching:false,current_record:{},error:false,error_message:'',show_assignees:false, querying:true, editing:false});
            this.componentDidMount();
        } else {
            this.setState({assign_view:false,search_name:'',search_ready:false,searching:false,current_record:{},error:false,error_message:'',show_assignees:false, editing:false});
        }
    }

    changeDeadlineDate = () => {
        this.setState({creating_nomination:true, search_ready:false});
        Gserv.sendCommand('update_intervention_deadline',this.props.gwt,{
            intervention_id: this.state.current_record.intervention_id,
            deadline_date: this.state.deadline
        })
        .then(reply => {
            // console.log('createNom reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (update_intervention_deadline) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (update_intervention_deadline) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else {
                this.resetMe();
                this.componentDidMount();
            }
        });
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1090
                }}
            >

                <Typography color='primary' style={{paddingTop:'15px'}}>
                    Assign Learning Interventions
                </Typography>

                {!this.state.assign_view&&!this.state.bulk_assign&&
                <div>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.setState({assign_view:true,primary_button_text:'Create Learning Intervention',current_record:{}})}
                        // disabled={this.state.assign_view}
                        style={{marginTop:'15px', marginLeft:'10px',marginRight:'10px'}}
                    >
                        Assign New
                    </Button>
                
                    {this.props.admin&&false&& //hidden for now - under construction
                    <Button
                        variant='contained'
                        // color='primary'
                        // type='submit'
                        onClick={()=>this.setState({bulk_assign:true,current_record:{}})}
                        // disabled={this.state.assign_view}
                        style={{marginTop:'15px',marginLeft:'10px',marginRight:'10px'}}
                        hidden={true}
                    >
                        Bulk Assign
                    </Button>}

                    <Typography style={{marginTop:'15px',marginBottom:'10px'}}>
                        Assigned Learning Interventions (not yet completed by employees)
                    </Typography>

                    <DatasheetView 
                        dataset={this.state.interventions_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={true}
                        edit={false}
                        handleDelete={this.handleDelete}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        height={500}
                    />
                </div>}

                {this.state.assign_view&&!this.state.bulk_assign&&
                <div>    
                    <hr/>

                    {!this.state.editing&&    
                    <Typography
                        // color='primary'
                        style={{paddingTop:'10px'}}
                    >
                        Assign a new Learning Intervention to an Employee:
                    </Typography>}


                    <Grid
                        container
                        direction='column'
                        justifyContent='space-evenly'
                        alignContent='center'
                        style={{padding:'20px'}}
                    >

                        {this.state.editing&& 
                        <div>
                            <Typography
                                style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                            >
                                A requirement for <strong>{this.state.current_record.employee}</strong> ({this.state.current_record.job_title}) to complete <strong>{this.state.current_record.intervention}</strong> was assigned by <strong>{this.state.current_record.assignor}</strong> on {this.state.current_record.created}
                            </Typography>   
                            <Typography
                                color='primary'
                                style={{paddingTop:'10px'}}
                            >
                                Edit Deadline Date for Assigned Learning Intervention:
                            </Typography>
                        </div>}


                        {this.state.intervention_templates_array&&
                        <Grid 
                            container
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                        >
                            {!this.state.editing&&
                            <div
                                style={{minWidth:'250px'}}
                            >
                            <DropDown
                                fieldMap={{
                                    field: "intervention_template_id",
                                    headerName: "Learning Intervention",
                                    f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true}}
                                setField={this.handleSelectUpdate}
                                editRecord={this.state.selected_template}
                                listArray={this.state.intervention_templates_array}
                                disabled={this.state.creating_nomination}
                                fullwidth={true}
                            />
                            </div>}

                            &nbsp;&nbsp;&nbsp;

                            <DatePicker
                                fieldMap={{
                                    field: "deadline_date",
                                    headerName: "Deadline Date?",
                                    f_inputType:'datepicker',
                                    f_required:false,
                                    f_show:true,
                                    f_disable_past:true}}
                                setField={this.handleDeadlineUpdate}
                                editRecord={this.state.current_record}
                                disabled={this.state.creating_nomination}
                            />

                        </Grid>}
                        
                        <form onSubmit={this.runSearch}>
                            <div>

                            {this.state.selected_template&&!this.state.editing&&
                            <div>
                            <TextField
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="on"
                                autoFocus={true}
                                label={'Surname Search'}
                                variant='outlined'
                                value={this.state.search_name}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                    const can_sub = (outText.length>2);
                                    this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                }}
                                // required
                                style={{marginBottom:'10px',marginTop:'15px',marginRight:'10px'}}
                                disabled={this.state.searching||this.state.error}
                                // inputRef={(element) => {this.textInput=element}}
                            />
                            <TextField
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                autoFocus={false}
                                label={'Employee # Search'}
                                variant='outlined'
                                value={this.state.search_number}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                    const can_sub = (outText.length>2);
                                    this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                }}
                                // required
                                style={{marginBottom:'10px', marginTop:'15px', marginLeft:'10px'}}
                                disabled={this.state.searching}
                            />
                            </div>}

                            <br/>
                            {this.state.selected_template&&!this.state.editing&&
                            <Button
                                variant='contained'
                                color='primary'
                                type='submit'
                                style={{marginLeft:'10px'}}
                                disabled={!this.state.search_ready}
                            >
                                Search
                            </Button>}

                            {this.state.selected_template&&!this.state.editing&&this.props.rom&&!this.props.admin&&false&& //under construction
                            <Button
                                variant='contained'
                                // color='primary'
                                // type='submit'
                                onClick={this.runViewAll}
                                style={{marginLeft:'10px'}}
                                disabled={this.state.searching||this.state.error}
                            >
                                View All
                            </Button>}

                            {this.state.editing&&    
                            <Button
                                variant='contained'
                                onClick={this.changeDeadlineDate}
                                style={{marginLeft:'10px'}}
                                color='primary'
                                // type='submit'
                                disabled={this.state.creating_nomination}
                            >
                                Update Deadline Date
                            </Button>}

                            <Button
                                variant='contained'
                                onClick={this.cancelUpdate}
                                style={{marginLeft:'10px'}}
                                // color='primary'
                                // type='submit'
                                disabled={this.state.creating_nomination}
                            >
                                Cancel
                            </Button>
                            </div>
                        </form>
                        
                    </Grid>
                </div>}

                {this.state.show_assignees&&this.state.selected_template&&
                <DatasheetView 
                    dataset={this.state.nominees_array}
                    fieldspecs={this.datasheetFieldSpecs2}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.searching}
                    deleteHeaderName={'Delete'}
                    height={350}
                />}

                {this.state.bulk_assign&&    
                <div>
                    <hr/>

                    <Typography
                        // color='primary'
                        style={{paddingTop:'10px'}}
                    >
                        Assign a Learning Intervention to all employees with a specified designation: <br/>
                        <strong>*** UNDER CONSTRUCTION ***</strong>
                    </Typography>
                </div>}

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1090,maxWidth:1090, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}